import type { LoopFetchProductResult } from '@server/utils/parseLoop/types';
import { createContext } from 'react';
import type { Dictionary } from 'types';

import type { MarketConfiguration } from '@/config/markets/const';

export type ProductPageContextProps = {
    loopProductData: LoopFetchProductResult;
    marketConfig: MarketConfiguration;
    dictionary: Dictionary;
};

export const ProductPageContext = createContext<
    ProductPageContextProps | undefined
>(undefined);
